module.exports = __webpack_public_path__ + "static/media/mar 2021.ec9b21c7.svg";